import { array, hash } from "@ember/helper";
import { LinkTo } from "@ember/routing";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";

export default <template>
  <LinkTo
    class="btn btn-transparent back-button"
    @models={{if @model (array @model) (array)}}
    @query={{or @query (hash)}}
    @route={{@route}}
  >
    {{dIcon "chevron-left"}}
    {{i18n (or @label "back_button")}}
  </LinkTo>
</template>
